import { lazy } from "react";
import { Routes } from "../constants/routes";
import DynamicPage from "../pages/dynamic/DynamicPage";
import PrivacyPolicyPage from "../pages/footer/privacy-policy/PrivacyPolicyPage";
import AccessibilityPlanPage from "../pages/footer/accessibility/AccessibilityPlanPage";
import TermConditionPage from "../pages/footer/term-conditions/TermConditionPage";

const OurPromisesLazy = lazy(
  () => import("../pages/about/our-promises/OurPromises")
);

const HistoryLazy = lazy(() => import("../pages/about/history/History"));
const HomeLazy = lazy(() => import("../pages/Home/Home"));
const RecoganizationAndAwardsLazy = lazy(
  () => import("../pages/about/recognization-and-awards/RecoganizationAndAward")
);
const SustainabilityLazy = lazy(
  () => import("../pages/about/sustainability/Sustainability")
);
const SafetyComplianceLazy = lazy(
  () => import("../pages/about/safety-compiances/SafetyCompliance")
);

const VisionCultureLazy = lazy(
  () => import("../pages/about/vision-culture/VisionCulture")
);

const LtlTruckingLazy = lazy(
  () => import("../pages/shipping-services/ltl-trucking/LtlTrucking")
);
const ServiceLevelLazy = lazy(
  () => import("../pages/shipping-services/service-level/ServiceLevel")
);

const FreightClassCalculatorlazy = lazy(
  () =>
    import(
      "../pages/shipping-services/freight-class-calculator/FreightClassCalculator"
    )
);

const FreightTimeCalculatorlazy = lazy(
  () =>
    import(
      "../pages/shipping-services/transit-time-calculator/TransitTimeCalculator"
    )
);

const TruckLoadServicelazy = lazy(
  () => import("../pages/shipping-services/truck-load-service/TruckLoadService")
);

const ExpeditedTruckinglazy = lazy(
  () =>
    import("../pages/shipping-services/expedited-trucking/ExpeditedTrucking")
);

const FlatbedTruckinglazy = lazy(
  () => import("../pages/shipping-services/flatbed-trucking/FlatbedTrucking")
);

const LocalCaritagelazy = lazy(
  () => import("../pages/shipping-services/local-caritage/LocalCaritage")
);

const HotFreightBillLadinglazy = lazy(
  () =>
    import(
      "../pages/shipping-forms/hot-freight-bill-of-lading/HotFreightBillLading"
    )
);

const CreditApplicationFormlazy = lazy(
  () =>
    import("../pages/shipping-forms/credit-application/CreditApplicationForm")
);

const ShippingApplicationFormlazy = lazy(
  () =>
    import(
      "../pages/shipping-forms/shipping-application/ShippingApplicationForm"
    )
);

const HotFreightCreditCardAuthorizationFormlazy = lazy(
  () =>
    import(
      "../pages/shipping-forms/hot-freight-credit-card-authorization-form/HotFreightCreditCardAuthorizationForm"
    )
);

const FreightQuoteFormlazy = lazy(
  () => import("../pages/resources/get-quote/freight-get-quote/FreightGetQuote")
);

const TradeShowQuotelazy = lazy(
  () => import("../pages/resources/get-quote/trade-show-quote/TradeShowQuote")
);

const GetAQuotelazy = lazy(
  () => import("../pages/resources/get-quote/get-quotes/GetAQuote")
);

const WarehousingQuotelazy = lazy(
  () =>
    import("../pages/resources/get-quote/warehousing-quote/WarehousingQuote")
);

const SouthernOntarioCanadianPointslazy = lazy(
  () =>
    import(
      "../pages/resources/transit-time/southern-ontario-and-canadian-points/SouthernOntarioCanadianPoints"
    )
);
const SouthernOntarioUSPointslazy = lazy(
  () =>
    import(
      "../pages/resources/transit-time/southern-ontario-and-US-points/SouthernOntarioUSPoints"
    )
);
const MonteralUsPointslazy = lazy(
  () =>
    import(
      "../pages/resources/transit-time/monteral-and-US-points/MonteralUsPoints"
    )
);

const VancouverandUSPointlazy = lazy(
  () =>
    import(
      "../pages/resources/transit-time/vancouver-and-US-Point/VancouverandUSPoint"
    )
);
const HalifaxandUsPointslazy = lazy(
  () =>
    import(
      "../pages/resources/transit-time/halifaxandUSpoints/HalifaxandUsPoints"
    )
);
const FootDryVanlazy = lazy(
  () => import("../pages/resources/equipments/53-foot-dry-van/53footDryVan")
);
const FlatbedTrailerlazy = lazy(
  () => import("../pages/resources/equipments/flatbed-trailer/FlatbedTrailer")
);

const DropDeckTrailerDatalazy = lazy(
  () =>
    import(
      "../pages/resources/equipments/drop-deck-trailer-data/DropDeckTrailerData"
    )
);
const StraightTrucklazy = lazy(
  () => import("../pages/resources/equipments/straight-truck/StraightTruck")
);
const TemperatureControlledVanlazy = lazy(
  () =>
    import(
      "../pages/resources/equipments/temperature-controlled-van/TemperatureControlledVan"
    )
);
const WhoAreWelazy = lazy(() => import("../pages/careers/who-we-are/WhoWeAre"));
const CareersAndOpportunitieslazy = lazy(
  () =>
    import("../pages/careers/careers-and-opportunities/CareersAndOpportunities")
);
const DriversOpportunitieslazy = lazy(
  () => import("../pages/careers/driver-opportunities/DriversOpportunities")
);
const DriverApplicationFormlazy = lazy(
  () => import("../pages/careers/driver-application-form/DriverApplicationForm")
);
const HeadQuaterlazy = lazy(
  () => import("../pages/contact/head-quaters-page/HeadQuater")
);
const JobDetailsPagelazy = lazy(
  () => import("../components/careers/JobDetailsPage")
);
const AllTransportationServiceslazy = lazy(
  () => import("../pages/shipping-services/Services/AllTransportationServices")
);
const AllWarehouseServiceslazy = lazy(
  () => import("../pages/shipping-services/Services/AllWareHouseServices")
);
const AllTradeshowServiceslazy = lazy(
  () => import("../pages/shipping-services/Services/AllTradeshowServices")
);

const Calculatorslazy = lazy(
  () => import("../pages/shipping-services/calculators/Calculators")
);
const ShipmentFormslazy = lazy(
  () => import("../pages/shipping-forms/tabs-shipment-forms/ShipmentForms")
);

const TransitTimeslazy = lazy(
  () => import("../pages/resources/transit-time/transit-times/TransitTimes")
);

const Equipmentslazy = lazy(
  () => import("../pages/resources/equipments/EquipmentsTabs")
);

const Serviceslazy = lazy(
  () => import("../pages/shipping-services/Services/Services")
);

const TransportationServiceslazy = lazy(
  () => import("../pages/shipping-services/Services/TransportationServices")
);

const WarehouseServiceslazy = lazy(
  () => import("../pages/shipping-services/Services/WarehouseServices")
);
const TradeshowServiceslazy=lazy(()=>import("../pages/shipping-services/Services/TradeshowServices"))

export const MainRoutes = [
  {
    path: Routes.Home,
    element: <HomeLazy />,
  },
  {
    path: Routes.OurPromises,
    element: <OurPromisesLazy />,
  },

  {
    path: Routes.History,
    element: <HistoryLazy />,
  },
  {
    path: Routes.RecoganizationAndAwards,
    element: <RecoganizationAndAwardsLazy />,
  },
  {
    path: Routes.Sustainability,
    element: <SustainabilityLazy />,
  },
  {
    path: Routes.SafetyCompliance,
    element: <SafetyComplianceLazy />,
  },
  {
    path: Routes.VisionCulture,
    element: <VisionCultureLazy />,
  },

  {
    path: Routes.LtlTrucking,
    element: <LtlTruckingLazy />,
  },
  {
    path: Routes.ServiceLevel,
    element: <ServiceLevelLazy />,
  },
  {
    path: Routes.FreightClassCalculator,
    element: <FreightClassCalculatorlazy />,
  },
  {
    path: Routes.TransitTimeCalculator,
    element: <FreightTimeCalculatorlazy />,
  },

  {
    path: Routes.TruckLoadService,
    element: <TruckLoadServicelazy />,
  },
  {
    path: Routes.ExpeditedTrucking,
    element: <ExpeditedTruckinglazy />,
  },

  {
    path: Routes.FlatbedTrucking,
    element: <FlatbedTruckinglazy />,
  },
  {
    path: Routes.LocalCaritage,
    element: <LocalCaritagelazy />,
  },

  {
    path: Routes.HotFreightBillLading,
    element: <HotFreightBillLadinglazy />,
  },

  {
    path: Routes.CreditApplicationForm,
    element: <CreditApplicationFormlazy />,
  },
  {
    path: Routes.ShippingApplicationForm,
    element: <ShippingApplicationFormlazy />,
  },

  {
    path: Routes.HotFreightCreditCardAuthorizationForm,
    element: <HotFreightCreditCardAuthorizationFormlazy />,
  },

  {
    path: Routes.FreightQuoteForm,
    element: <FreightQuoteFormlazy />,
  },
  {
    path: Routes.TradeShowQuote,
    element: <TradeShowQuotelazy />,
  },
  {
    path: Routes.GetAQuote,
    element: <GetAQuotelazy />,
  },
  {
    path: Routes.WarehousingQuote,
    element: <WarehousingQuotelazy />,
  },

  {
    path: Routes.SouthernOntarioCanadianPoints,
    element: <SouthernOntarioCanadianPointslazy />,
  },

  {
    path: Routes.SouthernOntarioUSPoints,
    element: <SouthernOntarioUSPointslazy />,
  },
  {
    path: Routes.MonteralUsPoints,
    element: <MonteralUsPointslazy />,
  },
  {
    path: Routes.VancouverandUSPoint,
    element: <VancouverandUSPointlazy />,
  },
  {
    path: Routes.HalifaxandUsPoints,
    element: <HalifaxandUsPointslazy />,
  },

  {
    path: Routes.FootDryVan,
    element: <FootDryVanlazy />,
  },
  {
    path: Routes.FlatbedTrailer,
    element: <FlatbedTrailerlazy />,
  },

  {
    path: Routes.DropDeckTrailer,
    element: <DropDeckTrailerDatalazy />,
  },
  {
    path: Routes.StraightTruck,
    element: <StraightTrucklazy />,
  },
  {
    path: Routes.TemperatureControlledVan,
    element: <TemperatureControlledVanlazy />,
  },
  {
    path: Routes.WhoAreWe,
    element: <WhoAreWelazy />,
  },
  {
    path: Routes.CareersAndOpportunities,
    element: <CareersAndOpportunitieslazy />,
  },

  {
    path: Routes.DriversOpportunities,
    element: <DriversOpportunitieslazy />,
  },

  {
    path: Routes.DriverApplicationForm,
    element: <DriverApplicationFormlazy />,
  },

  {
    path: Routes.HeadQuaters,
    element: <HeadQuaterlazy />,
  },
  {
    path: "/:slug",
    element: <DynamicPage />,
  },

  {
    path: Routes.JobDetails,
    element: <JobDetailsPagelazy />,
  },
  {
    path: Routes.AllTransportationServices,
    element: <AllTransportationServiceslazy />,
  },
  {
    path: Routes.AllWarehouseServices,
    element: <AllWarehouseServiceslazy />,
  },
  {
    path: Routes.AllTradeShowServices,
    element: <AllTradeshowServiceslazy />,
  },
  {
    path: Routes.Calculators,
    element: <Calculatorslazy />,
  },
  {
    path: Routes.ShipmentForms,
    element: <ShipmentFormslazy />,
  },
  {
    path: Routes.TransitTimes,
    element: <TransitTimeslazy />,
  },
  {
    path: Routes.Equipments,
    element: <Equipmentslazy />,
  },
  {
    path: Routes.Services,
    element: <Serviceslazy />,
  },
    {
    path: Routes.TradeshowServices,
    element: <TradeshowServiceslazy />,
  },
      {
    path: Routes.WarehouseServices,
    element: <WarehouseServiceslazy />,
  },
  {
    path: Routes.termCondition,
    element: <TermConditionPage />,
  },
     {
    path: Routes.privacyPolicy,
    element: <PrivacyPolicyPage />,
  },
     {
    path: Routes.accessibilityPlan,
    element: <AccessibilityPlanPage />,
  }
];
